import { ComponentProps } from "solid-js"

/**
 * NgageCode's marks. The mark is the "{}" of the wordmark (the o of "code"); the wordmark is set in the
 * UI's own sans so it follows every theme: "ngage" in the text colour, "c{}de" in NgageCode's lime.
 */
const LIME = "#d8d61e"

const Braces = (props: { stroke: string; width: number }) => (
  <g fill="none" stroke={props.stroke} stroke-width={props.width} stroke-linecap="round" stroke-linejoin="round">
    <path d="M9.4 3.2Q6.6 3.2 6.6 6V8.8Q6.6 10.4 4.6 10.4Q6.6 10.4 6.6 12V14.8Q6.6 17.6 9.4 17.6" />
    <path d="M12.6 3.2Q15.4 3.2 15.4 6V8.8Q15.4 10.4 17.4 10.4Q15.4 10.4 15.4 12V14.8Q15.4 17.6 12.6 17.6" />
  </g>
)

export const Mark = (props: { class?: string }) => {
  return (
    <svg
      data-component="logo-mark"
      classList={{ [props.class ?? ""]: !!props.class }}
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Braces stroke="var(--icon-strong-base)" width={2.6} />
    </svg>
  )
}

export const Splash = (props: Pick<ComponentProps<"svg">, "ref" | "class">) => {
  return (
    <svg
      ref={props.ref}
      data-component="logo-splash"
      classList={{ [props.class ?? ""]: !!props.class }}
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Braces stroke={LIME} width={2.6} />
    </svg>
  )
}

export const Logo = (props: { class?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 72"
      fill="none"
      classList={{ [props.class ?? ""]: !!props.class }}
      data-component="logo"
    >
      <text
        x="0"
        y="56"
        font-family="ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif"
        font-size="64"
        font-weight="600"
        letter-spacing="-1.5"
        fill="var(--icon-strong-base)"
      >
        ngage
        <tspan fill={LIME}>c{"{}"}de</tspan>
      </text>
    </svg>
  )
}
